import { z } from "zod";

import { machineSecurePrintConfiguration } from "./machine-secure-print-configuration";

const pl1MaterialSchema = z
	.object({
		id: z.string(),
		tenantId: z.string(),
		alias: z.string(),
		width: z.number(),
		thickness: z.number(),
		quality: z.number(),
	})
	.passthrough();

const pl1TrackConfigurationSchema = z
	.object({
		number: z.number(),
		isTrackEmpty: z.boolean().optional(),
		assignedMaterial: pl1MaterialSchema.nullish(),
	})
	.passthrough();

const pl1SettingsTrack = z
	.object({
		installed: z.boolean(),
		materialBrand: z.string().optional(),
		materialWidth: z.number().optional(),
		materialThickness: z.number().optional(),
		isEmpty: z.boolean(),
	})
	.passthrough();

const pl1PlcSettings = z
	.object({
		track1: pl1SettingsTrack.optional(),
		track2: pl1SettingsTrack.optional(),
		track3: pl1SettingsTrack.optional(),
	})
	.passthrough();

const baseMachineConfigurationSchema = z.object({
	id: z.string(),
	tenantId: z.string().optional(),
	iotEdgeDeviceId: z.string().nullish(),
	iotEdgeModuleId: z.string().nullish(),
	edgeModuleVersion: z.string().nullish(),
	isUpgraded: z.boolean().optional(),
	configurationVersion: z.number().optional(),
	edgeModuleVersionLastUpdated: z.string().optional(),
	iotHubName: z.string().nullish(),
	alias: z.string().optional(),
	description: z.string().optional(),
	machineType: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().optional(),
	assetId: z.string().optional(),
	plcVersion: z.string().nullish(),
	sessionNumber: z.number().optional(),
	sessionNumberTimeStamp: z.string().optional(),
	lastSequenceNumber: z.number().optional(),
	lastProofOfLifeTimeStamp: z.string().optional(),
	status: z.string().optional(),
	productionStatus: z.string().optional(),
	isReadyForWork: z.boolean().optional(),
	packMlMode: z.string().optional(),
	packMlState: z.string().optional(),
	lastStopReasonSequenceNumber: z.number().optional(),
	userName: z.string().optional(),
	messageId: z.string().optional(),
	securePrintConfiguration: machineSecurePrintConfiguration,
});

export const pl1MachineSchema = baseMachineConfigurationSchema.extend({
	unit: z.string().optional(),
	tracks: z.array(pl1TrackConfigurationSchema),
	plcSettings: pl1PlcSettings.optional(),
});

export type PL1Machine = z.infer<typeof pl1MachineSchema>;
export type PL1TrackConfiguration = z.infer<typeof pl1TrackConfigurationSchema>;
